export const DEFAULT_LIST_DATA = Object.freeze({
  items: [],
  total_items: 0,
  total_pages: 0,
})
